module.exports = __webpack_public_path__ + "static/media/mobile-sync-square.448adf76.png";